/** Keyword-friendly paths that redirect to the canonical Quran PDF page. */
export const QURAN_PDF_REDIRECT_PATHS = [
    "/quran-pdf",
    "/quran-download",
    "/download-quran",
    "/pdf-quran",
    "/download-quran-pdf",
    "/quran-pdf-english",
    "/english-quran-pdf",
    "/download-quran-english",
    "/quran-pdf-arabic",
    "/arabic-quran-pdf",
    "/download-quran-arabic",
    "/quran-pdf-urdu",
    "/urdu-quran-pdf",
    "/quran-pdf-hindi",
    "/hindi-quran-pdf",
    "/surah-yasin-pdf",
    "/download-surah-yasin-pdf",
    "/surah-mulk-pdf",
    "/download-surah-mulk-pdf",
    "/surah-kahf-pdf",
    "/download-surah-kahf-pdf",
    "/ayatul-kursi-pdf",
    "/download-ayatul-kursi-pdf",
];

export const QURAN_PDF_CANONICAL_PATH = "/quran-pdf-download";
